import React from 'react';
import Proptypes from 'prop-types';
import styled from 'styled-components';
import {SVGICONS} from '@ey/icons';
import {labels} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import InlineMessage from '../BaseComponentWrappers/MotifInlineMessage';

function BannerMessage(props) {
	const {message, variant, className, onClose} = props;

	return (
		<StyledBannerMessage className={`StyledBannerMessage ${className}`}>
			<section className={variant + ' color-block'} />
			<InlineMessage
				className={'inline-message'}
				variant={variant}
				children={<span className="error-message">{Utility.createRichTextElement(message)}</span>}
			/>

			<section className={'close-icon-wrapper'}>
				<SVGICONS
					styleName="medium pull-right close-icon"
					hoverText={labels.closeLabel}
					name="close-outline"
					onIconClick={onClose}
				/>
			</section>
		</StyledBannerMessage>
	);
}

export default BannerMessage;

const StyledBannerMessage = styled.section`
	display: flex;
	border: var(--px-1) solid var(--neutrals-300);
	box-shadow: 0 0 var(--px-16) 0 rgba(0, 0, 0, 0.2);
	margin: var(--px-20);
	.color-block {
		width: var(--px-100);
	}
	.error {
		background-color: var(--red-600);
	}
	.warning {
		background-color: var(--orange-200);
	}
	.success {
		background-color: var(--green-500);
	}
	.inline-message {
		padding: var(--px-10) 0;
		.motif-inline-message-content {
			position: relative;
			right: var(--px-10);
			svg {
				left: calc(var(--px-20) * -1);
				fill: var(--neutrals-00white);
				width: var(--px-24);
				height: var(--px-24);
				max-width: 100%;
				max-height: 100%;
				min-width: var(--px-24);
			}
			.error-message {
				span {
					font-size: var(--px-14);
					font-weight: 300;
					line-height: var(--px-22);
				}
			}
		}
	}
	.close-icon-wrapper {
		padding: var(--px-10);
		svg {
			fill: var(--neutrals-900);
		}
	}
`;

BannerMessage.proptypes = {
	message: Proptypes.string.isRequired,
	variant: Proptypes.oneOf(['error', 'warning', 'success']),
	className: Proptypes.string
};

BannerMessage.defaultProps = {
	variant: 'warning'
};
